import { render, staticRenderFns } from "./build.vue?vue&type=template&id=f56fd9a0&scoped=true&"
import script from "./build.vue?vue&type=script&lang=js&"
export * from "./build.vue?vue&type=script&lang=js&"
import style0 from "./build.vue?vue&type=style&index=0&id=f56fd9a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56fd9a0",
  null
  
)

export default component.exports